import { namespace } from 'vuex-class';
import { IFoldersState } from './folders.types';

export const ContractManagementFolders = namespace('contractManagement/contractManagementFolders');

export function getDefaultState(): IFoldersState {
  return {
    loading: false,
    loaded: false,
    folders: [],
    breadcrumbs: [],
  };
}
